export const WEB3 = {
  nullAddress: '0x0000000000000000000000000000000000000000',
  nullStateHash: '0x0000000000000000000000000000000000000000000000000000000000000000',
};
